// class
// utils
import { codeGeneretor, compareObjects } from 'app/utils';
import _ from 'lodash';

// TODO: transformar as variáveis e métodos realmente privados utilizando # (estudar possibilidade)

/**
 * Essa classe pode ser utilizado caso o estado passado para o construtor
 * siga a mesma estrutura do pad equipment, furniture, etc
 */

/**
 * represents an instance of pad creator
 * @class PadCreator
 */
export default class PadCreator {
  /**
   * @param {object} state - pad creator element state
   * @returns {this}
   */
  constructor(state) {
    this._state = _.cloneDeep(state);
    this._screenData = _.cloneDeep(state.data.screen);
    this._loadedData = _.cloneDeep(state.data.loaded);
  }

  /**
   * remove a element.
   * @param {string} code - element`s code to remove.
   * @returns {object} return the state
   */
  remove(code) {
    const newScreen = this._screenData.filter(currentElement => currentElement.code !== code);

    this._screenData = newScreen;

    return this;
  }

  /**
   * update a element.
   * @param {string} code - element`s code to update.
   * @param {object} data - data to update.
   * @returns {object} return the state
   */
  update(code, data = {}) {
    const indexScreenToEdit = this._findIndexByCode(code, this._screenData);

    Object.entries(data).forEach(([key, content]) => {
      this._screenData[indexScreenToEdit][key] = content;
    });

    this._screenData[indexScreenToEdit]['itHasBeenEdited'] = this._hasBeenElementUpdated(code);

    return this;
  }

  /**
   * insert a new element.
   * @param {object} element - new element.
   * @returns {object} the state
   */
  insert(element, propsToAdd = {}) {
    element.code = codeGeneretor();
    element.status = 1;

    Object.entries(propsToAdd).forEach(([key, value]) => {
      element[key] = value;
    });

    this._screenData.push(element);

    return this;
  }

  /**
   * get state.
   * @returns {object} the pad creator element state
   */
  getState() {
    this._state.data.screen = this._screenData;
    this._state.data.loaded = this._loadedData;
    return this._state;
  }

  /**
   * change loading state.
   * * @param {Boolean} Boolean - state of loading.
   * @returns {this}
   * @default Boolean is true
   */
  setLoading(paramBoolean = true) {
    this._state.loading = paramBoolean;

    return this;
  }

  setErrors(errors = []) {
    this._state.errors = errors;

    return this;
  }

  /**
   * checks that the loaded element is different from the one shown
   * @param {String} code - element's code to check
   * @returns {Boolean}
   */
  _hasBeenElementUpdated(code) {
    const indexScreen = this._findIndexByCode(code, this._screenData);
    const indexLoaded = this._findIndexByCode(code, this._loadedData);

    if (indexLoaded === -1) return false;
    if (indexScreen === -1) return false;

    const isDifferentFromTheOriginal = !compareObjects(
      this._screenData[indexScreen],
      this._loadedData[indexLoaded],
      ['itHasBeenEdited']
    );

    return isDifferentFromTheOriginal;
  }

  /**
   * Find index array by code
   * @param {String} code - element's code to check
   * @returns {number} index
   */
  _findIndexByCode(code, arr) {
    return arr.findIndex(item => item.code === code);
  }

  /**
   * Find element in array by filter
   * @param {Object} filter - filter to check
   * @returns {Object} element or undefined
   */
  _findOneBy(filter, arr) {
    return arr.filter(element =>
      Object.entries(filter).every(([key, value]) => element[key] === value)
    )[0];
  }
}
